<template>
  <v-card @click="$emit('click', { id: coreCard.id, categoryId: null })">
    <v-card-text>
      <v-row>
        <v-col cols="auto" class="my-auto">
          <v-img :src="$images.PULSE_ICON" v-if="coreCard.isPulse"></v-img>
          <v-icon color="secondary" size="50" v-else-if="icon">
            {{ icon }}
          </v-icon>
        </v-col>
        <v-col>
          <v-card-title class="pt-0">
            {{ coreCard.name }}
          </v-card-title>
          <v-card-subtitle>{{ coreCard.insightDescription }}</v-card-subtitle>
          <v-chip
            v-for="(category, i) in categories"
            :key="i"
            outlined
            class="mr-1"
            @click.stop="
              $emit('click', { id: coreCard.id, categoryId: category.id })
            "
          >
            <span v-html="category.icon" class="mr-2"></span>
            {{ category.count }}
          </v-chip>
        </v-col>
        <v-spacer class="limited-spacer"></v-spacer>
        <v-icon small class="mr-2">east</v-icon>
      </v-row>
    </v-card-text>
  </v-card>
</template>

<script>
import { mapGetters } from "vuex";
export default {
  name: "InsightCoreCard",
  props: { coreCard: { type: Object } },
  computed: {
    icon() {
      if (this.coreCard.isReview) {
        return "360";
      } else if (this.coreCard.id == this.$enums.coreCardTypes.ENGAGEMENT) {
        return "directions_bike";
      }
      return "";
    },
    categories() {
      return this.insight_categories.map(x =>
        Object.assign(x, {
          count: this.insights.filter(
            y =>
              y.type.coreCardTypeId == this.coreCard.id &&
              y.type.categoryId == x.id
          ).length
        })
      );
    },
    ...mapGetters({
      insights: "insights/list",
      insight_categories: "lookup/insight_categories"
    })
  }
};
</script>
